import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "../data/content";

export const Testimonials = () => {
  return (
    <section
      id="reviews"
      data-testid="testimonials-section"
      className="bg-[#F6F5F0] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto">
          <div className="flex items-center justify-center gap-1 text-[#C4A575] mb-4">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} size={18} fill="#C4A575" strokeWidth={0} />
            ))}
          </div>
          <p className="uppercase text-xs tracking-[0.25em] text-[#C4A575] font-semibold">
            Guest Stories
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-primary mt-4 leading-tight">
            Loved by those who came to disappear
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mt-16">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              className="bg-[#EFECE4] border border-border/40 p-8 flex flex-col"
              data-testid={`testimonial-card-${i}`}
            >
              <Quote size={28} className="text-[#C4A575]" />
              <p className="font-serif text-xl text-primary mt-5 leading-snug italic flex-1">
                "{t.quote}"
              </p>
              <div className="mt-7 pt-5 border-t border-border/50">
                <p className="text-sm font-semibold text-primary">{t.name}</p>
                <p className="text-xs uppercase tracking-[0.15em] text-text-muted mt-0.5" style={{ color: "#5A655E" }}>
                  {t.from}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
